// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1VODH","bigColWidth":"Table_bigColWidth__2Zku1","biggerColWidth":"Table_biggerColWidth__2Qgnl","row":"Table_row__1hxuQ","col":"Table_col__2MFIh"};